module.exports = __webpack_public_path__ + "static/media/card-cursos-livres.62e8d65c.png";